



























































import { Component, Vue } from "vue-property-decorator";
import roomStore from "@/../api/room.store";
import Room from "@/components/Room.vue";
import { BoxedValue, RoomStatus } from "@/../api/data";
import userStore from "@/../api/user.store";

@Component({ components: { Room } })
export default class Main extends Vue {
  rooms: RoomStatus[] = roomStore.rooms();
  nameSet: BoxedValue<boolean> = userStore.isNameSet();
}
